import styled from 'styled-components';
import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled.div<{ amount: number }>`
  border: ${({ theme: { system } }) =>
    `${system.fds_sys_borderwidth_S} solid ${system.border.fds_sys_color_border_primary}`};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  width: ${({ amount }) => (amount >= 3 ? '355px' : '540px')};
  position: relative;
  padding: ${({ theme: { reference } }) => reference.dimension_24};
  margin-top: ${({ theme: { reference } }) => reference.dimension_16};
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    width: 300px;
    margin: ${({ theme: { reference } }) => reference.dimension_08};
  }
`;

export const Recommended = styled.div<{ isRecommended: boolean }>`
  visibility: ${({ isRecommended }) => (isRecommended ? 'visible' : 'hidden')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_primary_inverse};
  padding: ${({ theme: { reference } }) => `${reference.dimension_04} 0`};
  border-radius: ${({ theme: { system } }) =>
    `${system.fds_sys_borderradius_L} ${system.fds_sys_borderradius_L} 0 0`};
`;

export const BackgroundImage = styled.div<{ plan: string }>`
  position: relative;
  width: 100%;
  border-radius: ${({ theme: { reference } }) =>
    ` 0 0 ${reference.dimension_80} ${reference.dimension_80}`};
  overflow: hidden;
  ::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    background-color: ${({ theme: { system }, plan }) =>
      system.plans[`fds_sys_color_plan_${plan}_quaternary`]};
    border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_O};
    width: 100%;
    height: 160px;
  }
  img {
    display: block;
    position: relative;
    max-height: 247px;
    margin: 0 auto;
    z-index: 5;
  }
`;

export const Discount = styled(Text)`
  text-decoration: ${({ theme: { reference } }) => `${reference.brand.dark_500} line-through`};
`;

export const CheckoutButton = styled(Buttons.Classic)`
  width: 100%;
`;

export const MoreInfoButton = styled(Buttons.Tiny)`
  svg {
    width: ${({ theme: { reference } }) => reference.dimension_08};
    height: ${({ theme: { reference } }) => reference.dimension_08};
  }
`;

export const EfirmaContainer = styled(FlexContainer)`
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  height: 100%;
`;
